import { lazy } from "react";
import { RouterItemType } from "@/app/index";

const LayoutPageSearch = lazy(() => import("./layout/index"));

export const routerPageSearch: RouterItemType = {
  path: "/support",
  authorize: false,
  element: <LayoutPageSearch />,
};
